import React, { useEffect } from 'react';

import { useMortalityContext } from '../contexts/MortalityContext';

const formatDate = (date: Date) =>
  date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

export function HistoryPage() {
  const {
    history,
    deleteCalculation,
    clearHistory,
    loadMoreHistory,
    historyHasMore,
    historyLoading,
    refreshHistory,
    syncingHistory,
    historySyncError,
    syncHistoryNow,
  } = useMortalityContext();

  useEffect(() => {
    refreshHistory().catch(error => {
      console.error('Failed to refresh history', error);
    });
  }, [refreshHistory]);

  const handleDelete = (id: string) => {
    deleteCalculation(id).catch(error => {
      console.error('Failed to delete calculation', error);
    });
  };

  const handleClear = () => {
    clearHistory().catch(error => {
      console.error('Failed to clear history', error);
    });
  };

  const handleLoadMore = () => {
    loadMoreHistory().catch(error => {
      console.error('Failed to load more history', error);
    });
  };

  const handleSync = () => {
    syncHistoryNow().catch(error => {
      console.error('Failed to sync history', error);
    });
  };

  return (
    <section className="panel">
      <div className="section-header">
        <div>
          <h1 className="section-title">History</h1>
          <p className="muted">Saved calculations synced with your Longevity Services account.</p>
        </div>
        <div className="actions">
          <button className="button-secondary" type="button" onClick={handleSync} disabled={syncingHistory}>
            {syncingHistory ? 'Syncing…' : 'Sync now'}
          </button>
          <button className="button-secondary" type="button" onClick={handleClear} disabled={!history.length}>
            Clear history
          </button>
        </div>
      </div>

      {historySyncError ? <p className="auth-error">{historySyncError}</p> : null}

      <div className="history-table-wrapper">
        <table className="history-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Age / Gender</th>
              <th>Conditions</th>
              <th>Risk</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {history.map(entry => (
              <tr key={entry.id}>
                <td>{formatDate(entry.timestamp)}</td>
                <td>
                  {entry.age} / {entry.gender}
                </td>
                <td>{entry.selectedConditions.length}</td>
                <td>{entry.riskLevel ?? 'N/A'}</td>
                <td>
                  <button className="link-button" type="button" onClick={() => handleDelete(entry.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="actions" style={{ marginTop: '1rem' }}>
        <button className="button-primary" type="button" onClick={handleLoadMore} disabled={!historyHasMore || historyLoading}>
          {historyLoading ? 'Loading…' : historyHasMore ? 'Load more' : 'No more entries'}
        </button>
      </div>
    </section>
  );
}
